// The Scripts list's rows for the chosen view, status chip and filters (TWEAK-2). No imports: tests/listRows.test.mjs
// loads this file as it is.
//
// Backburner is outside the working set (Owner 2026-10-26): the Active view's All leaves it out, its own chip lists it,
// and a search still finds a Backburner script by its title. Archived and Deleted show every row they hold, as before.
//   view          'active' | 'archived' | 'deleted'
//   statusFilter  '' (All) or a chip value. 'Filming' and 'Posted' are server shelves: the fetched rows already are the set.
// Returns { rows, base }: rows in the fetched order; base is the set the header meta counts against ("n of base"), which in
// the Active view leaves Backburner out unless its chip is on.
export function scriptListRows(scripts, { view = 'active', statusFilter = '', clientFilter = '', writerFilter = '', search = '' } = {}) {
  const isBackburner = s => s.qualStatus === 'Backburner';
  const hideBackburner = view === 'active' && !statusFilter;
  const q = search.toLowerCase();
  const titleHas = s => !!s.scriptName?.toLowerCase().includes(q);
  const rows = scripts.filter(s => {
    if (statusFilter && statusFilter !== 'Filming' && s.qualStatus !== statusFilter) return false;
    if (clientFilter && s.clientId !== clientFilter) return false;
    if (writerFilter && s.writerId !== writerFilter) return false;
    if (hideBackburner && isBackburner(s)) return !!q && titleHas(s);
    return !q || titleHas(s) || !!s.client?.name?.toLowerCase().includes(q) || !!s.writer?.name?.toLowerCase().includes(q);
  });
  const base = view !== 'active' ? scripts
    : statusFilter === 'Backburner' ? scripts.filter(isBackburner) : scripts.filter(s => !isBackburner(s));
  return { rows, base };
}
